<template>
  <div>
    <i ref="" class="b2b-grid__icon material-icons" @click="expandRow">
      add_box
    </i>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  inject: ['item'],
  methods: {
    expandRow() {
      console.log('expandRow()');
      this.item.rowData.expanded = !this.item.rowData.expanded;
    },
  },
};
</script>
